import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import ApiDevice from "../device/ApiDevice";

// Страница «Задачи» (authorized/admin/tasks) — TasksController. Ответ {active, queued, recent}
// не похож на CRUD-список, formatterItem отключен. Index() — обычный GET; Cancel/CancelQueued —
// POST-действия через __PostAction (тот же паттерн, что ApiDevice.Action/ChangeType).
export default class ApiTask extends ApiModelWithAuth {
    pathDef = 'authorized/admin/tasks';
    formatterItem = null;

    // Свой Index вместо унаследованного: базовый ApiModel.Index() ставит __responseIsArray=true,
    // а parseResponse при этом заменяет любой не-массив на [] — ответ {active,queued,recent}
    // молча превращался в пустой массив, и все три секции страницы были пустыми, хотя в сети
    // данные приходили.
    static Index() {
        const api = new this();
        api.__type = 'index';

        return api;
    }

    static __PostAction(path, params = {}) {
        const api = new this();
        api.__type = 'store';
        api.paths = { store: path };
        api.__params = params;
        api.formatterItem = null;

        return api;
    }

    // Отмена выполняющегося/ожидающего запуска: family — 'device'|'node'|'redroid', id — id
    // строки *_script_executes → {ok}. Кооперативная — останавливается не мгновенно.
    static Cancel(family, id) {
        return this.__PostAction('authorized/admin/tasks/cancel', { family, id });
    }

    // Отмена задачи в очереди (Laravel jobs, ещё не подхвачена queue:work) → {ok}.
    static CancelQueued(jobId) {
        return this.__PostAction('authorized/admin/tasks/cancel-queued', { job_id: jobId });
    }

    // Ход запусков по номерам (GET tasks/statuses?device[]=…&redroid[]=…): семьи раздельно — номера в
    // таблицах пересекаются; до 500 на семью → {data: [{family, id, device_id, status, finished, error…}]}.
    // Через FetchWithAuth: массивы в query ApiModel не собирает.
    static async Statuses({ device = [], redroid = [] }) {
        const query = [
            ...device.map((id) => `device[]=${id}`),
            ...redroid.map((id) => `redroid[]=${id}`),
        ].join('&');
        const response = await ApiDevice.FetchWithAuth(`authorized/admin/tasks/statuses?${query}`);
        return response.ok ? response.json() : null;
    }

    // Отмена пачкой (POST tasks/cancel-batch {device: [...], redroid: [...]}) → {result, cancelled, data}.
    // Ожидающие — сразу, идущие — на ближайшей контрольной точке. Право admin.tasks.edit.
    static async CancelBatch({ device = [], redroid = [] }) {
        const response = await ApiDevice.FetchWithAuth('authorized/admin/tasks/cancel-batch', {
            method: 'POST',
            body: { device, redroid },
        });
        return response.ok ? response.json() : null;
    }
}
